import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-md';
import cn from 'classnames';

class MyToolbar extends React.Component {
  static propTypes = {
    view: PropTypes.string.isRequired,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    label: PropTypes.node.isRequired,
    messages: PropTypes.object,
    onNavigate: PropTypes.func.isRequired,
    onViewChange: PropTypes.func.isRequired,
  }

  navigate = (action) => {
    this.props.onNavigate(action);
  }

  view = (view) => {
    this.props.onViewChange(view);
  }

  viewNamesGroup(messages) {
    const { view, views: viewNames } = this.props;

    if (viewNames.length > 1) {
      return viewNames.map(name => (
        <Button
          flat
          key={name}
          className={cn({ 'rbc-active': view === name })}
          onClick={() => this.view(name)}
        >
          {messages[name]}
        </Button>
      ));
    }
    return false;
  }

  render() {
    const { messages, label } = this.props;

    return (
      <div className="my-toolbar">
        <span >
          <Button
            icon
            onClick={() => this.navigate('PREV')}
          >
            navigate_before
          </Button>
          <Button
            flat
            onClick={() => this.navigate('TODAY')}
          >
            {messages.today}
          </Button>

          <Button
            icon
            onClick={() => this.navigate('NEXT')}
          >
            navigate_next
          </Button>
        </span>

        <span className="rbc-toolbar-label">{label}</span>

        <span className="rbc-btn-group">{this.viewNamesGroup(messages)}</span>
      </div>
    );
  }
}

export default MyToolbar;



// WEBPACK FOOTER //
// ./src/components/Calendar/MyToolbar.js